import { ActionType } from 'Redux/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case ActionType.GET_CLIENT:
      return { ...action.data };
    default:
      return { ...state };
  }
};
